import { isDevAuthBypassEnabled } from '@/lib/dev/auth-bypass-flag';

export function DevBypassBanner() {
  if (!isDevAuthBypassEnabled) return null;
  return (
    <div
      role="status"
      className="pointer-events-none fixed bottom-3 right-3 z-[100] rounded-md border border-amber-500/50 bg-amber-50/95 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-amber-900 shadow-lg backdrop-blur"
    >
      Dev auth bypass active
    </div>
  );
}
